export var FileSource;
(function (FileSource) {
    FileSource["Email"] = "email";
    FileSource["Web"] = "web";
})(FileSource || (FileSource = {}));
//# sourceMappingURL=file.js.map